import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
// import { ProgressBar } from 'primereact/progressbar';
// import ProductService from '../service/ProductService';
// import CustomerService from '../service/CustomerService';
//import OCDSApiService from '../service/OCDSApiService';
import { TabPanel, TabView } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';
import '../assets/css/DataTableStyle.css';
import PlanningApiService from '../service/PlanningApiService';


export const PlanningRecords = () => {

    // const [customer1, setCustomer1] = useState(null);
    // const [customer2, setCustomer2] = useState(null);
    // const [customer3, setCustomer3] = useState(null);
    const [records, setRecords] = useState(null);
    const [existingYears, setExistingYears] = useState(null);
    // const [selectedCustomers, setSelectedCustomers] = useState(null);
    // const [globalFilter1, setGlobalFilter1] = useState('');
    // const [globalFilter2, setGlobalFilter2] = useState('');
    const [globalFilter3, setGlobalFilter3] = useState('');
    // const [loading1, setLoading1] = useState(true);
    const [loading2, setLoading2] = useState(true);
    // const [products, setProducts] = useState(null);
    const [expandedRows, setExpandedRows] = useState([]);
    const toast = useRef(null);
    const [monthValue, setMonthValue] = useState('');
    const [yearValue, setYearValue] = useState('');

    const months = [
        { name: 'January', code: '1' },
        { name: 'February', code: '2' },
        { name: 'March', code: '3' },
        { name: 'April', code: '4' },
        { name: 'May', code: '5' },
        { name: 'June', code: '6' },
        { name: 'July', code: '7' },
        { name: 'August', code: '8' },
        { name: 'September', code: '9' },
        { name: 'October', code: '10' },
        { name: 'November', code: '11' },
        { name: 'December', code: '12' },
    ];

    useEffect(() => {
        const planningApiService = new PlanningApiService();
        planningApiService.getPlannings().then(data => {  setRecords(data); setLoading2(false)});
        
        planningApiService.getExistingYears().then(data => setExistingYears(data));
    }, []);

    const onRowExpand = (event) => {
        //toast.current.show({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
    };

    const onRowCollapse = (event) => {
        //toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    };

  
    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'NGN' });
    };

    const formatDate = (value) => {
        return new Intl.DateTimeFormat('en-GB', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
        }).format(new Date(value))
    };

  
    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const objectBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field].name}
            </>
        );
    };

    const awardStatusBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field][0].status}
            </>
        );
    };

    const arrayBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field][0].title}
            </>
        );
    };

    const contractorBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field][0].suppliers[0].name}
            </>
        );
    };

    
    // const actionTemplate = () => <Button type="button" icon="pi pi-cog" className="p-button-secondary"></Button>;

    const productsTableHeader = (
        <div className="table-header">
            {/* <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} className="p-mr-2" />
            <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} /> */}
            List of Planning Records
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter3} onChange={(e) => setGlobalFilter3(e.target.value)} placeholder="Search" />
            </span>
        </div>
    );

   
    const contractAmountBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">Price</span>
                {formatCurrency(data[props.field])}
            </>
        );
    };

    const contractDateBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">Price</span>
                {formatDate(data[props.field])}
            </>
        );
    };

    

    const detailRowExpansionTemplate = (data) => {
        return (
            <div className="orders-subtable">
                <h5>Details for Planning</h5>
                <div className="p-d-flex p-flex-nowrap" style={{}}>
                            {/* <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "font-weight": "bold" }}>Tender Items</div> */}
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "width": "100%" }}>
                                <DataTable value={data.planningmilestones} className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers">
                                    <Column field="id" header="Code" sortable body={bodyTemplate}></Column>
                                    <Column field="description" header="Description" sortable body={bodyTemplate}></Column>
                                    <Column field="milestonetypetitle" header="Milestone Type" sortable body={bodyTemplate}></Column>
                                    <Column field="duedate" header="Due Date" sortable body={bodyTemplate}></Column>
                                    <Column field="milestonestatus" header="Milestone Status" sortable body={bodyTemplate}></Column>
                                    <Column field="milestonemetdate" header="Met date" sortable body={bodyTemplate}></Column>
                                    {/* <Column field="quantity" header="Quantity" sortable body={bodyTemplate}></Column> */}
                                </DataTable>
                            </div>
                        </div>
                {/* <TabView>
                    <TabPanel header="Planning Milestones" style={{ "background-color": "blue" }}>

                        <div className="p-d-flex p-flex-nowrap" style={{}}>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "font-weight": "bold" }}>Project</div>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "width": "100%" }}><p>{data.planning.budget.project}</p></div>
                        </div>
                        <div className="p-d-flex p-flex-nowrap" style={{}}>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "white", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "font-weight": "bold" }}>Rationale</div>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "white", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "width": "100%" }}><p>{data.planning.rationale}</p></div>
                        </div>
                        <div className="p-d-flex p-flex-nowrap" style={{}}>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "font-weight": "bold" }}>Budget Reference</div>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "width": "100%" }}><p>{data.planning.budget.id}</p></div>
                        </div>
                        <div className="p-d-flex p-flex-nowrap" style={{}}>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "white", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "font-weight": "bold" }}>Budget Description</div>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "white", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "width": "100%" }}><p>{data.planning.budget.description}</p></div>
                        </div>
                        <div className="p-d-flex p-flex-nowrap" style={{}}>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "font-weight": "bold" }}>Budget Amount</div>
                            <div className="p-mr-2 p-mb-2" style={{ "background-color": "#e9f5f7", "padding": "10px", "border": "0.5px solid #999", "border-spacing": "0.5rem", "width": "100%" }}><p>{formatCurrency(data.planning.budget.amount.amount)}</p></div>
                        </div>

                    </TabPanel>
                    
                </TabView> */}
               
            </div>
        );
    };

    

    const handleSearchButton = (e) => {
        e.preventDefault();
        // setLoading2(true);
        // const oCDSApiService = new OCDSApiService();
        // var selectedmonth = monthValue === '' ? 0 : monthValue.code;
        // var selectedyear = yearValue === '' ? 0 : yearValue.code;
        // if (selectedyear === 0 && selectedmonth !== 0) {
        //     alert("Please select a year");
        // } else {
        //     oCDSApiService.getRecordsWithYearAndMonth(selectedyear, selectedmonth).then(data => { setRecords(data); setLoading2(false) });
        // }
    };

    const handleClearButton = (e) => {
        e.preventDefault();
        // setLoading2(true);
        // setYearValue('');
        // setMonthValue('');
        // const oCDSApiService = new OCDSApiService();
        // oCDSApiService.getRecords().then(data => { setRecords(data); setLoading2(false)} );
    };

    return (
        <div className="p-grid table-demo">
         
            <div className="p-col-12">
                {/* <div className="card">
                    <h5>Search with Year & Month</h5>
                    <br />
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-3">
                            <span className="p-float-label">
                                <Dropdown id="existingyear" options={existingYears} value={yearValue} onChange={(e) => setYearValue(e.value)} optionLabel="name"></Dropdown>
                                <label htmlFor="existingyear">Select Year</label>
                            </span>
                        </div>
                        <div className="p-field p-col-12 p-md-3">
                            <span className="p-float-label">
                                <Dropdown id="dropdown" options={months} value={monthValue} onChange={(e) => setMonthValue(e.value)} optionLabel="name"></Dropdown>
                                <label htmlFor="dropdown">Select Month</label>
                            </span>
                        </div>
                        <div className="p-field p-col-12 p-md-2">
                            <Button label="Search" className="p-button-outlined p-button-info p-mr-2 p-mb-2" icon="pi pi-search" onClick={handleSearchButton}></Button>
                        </div>
                        <div className="p-field p-col-12 p-md-2">
                            <Button label="Clear fields" className="p-button-outlined p-button-warning p-mr-2 p-mb-2" icon="pi pi-times" onClick={handleClearButton}></Button>
                        </div>

                    </div>
                </div> */}
                <div className="card">
                    {/* <h5>Row Expand</h5> */}

                    <Toast ref={toast} />
                    <DataTable value={records} expandedRows={expandedRows} className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers" dataKey="id" onRowToggle={(e) => setExpandedRows(e.data)} onRowExpand={onRowExpand} onRowCollapse={onRowCollapse}
                        rowHover globalFilter={globalFilter3} emptyMessage="No records found." loading={loading2} header={productsTableHeader} rowExpansionTemplate={detailRowExpansionTemplate}>
                        <Column expander headerStyle={{ width: '3rem' }} />                  
                        <Column field="financialperiod" header="Financial Year" headerStyle={{ width: '6rem', textAlign: 'center' }} sortable body={bodyTemplate}></Column>
                        <Column field="mdadescription" header="MDA" headerStyle={{ width: '8rem', textAlign: 'center' }} sortable body={bodyTemplate}></Column>
                        <Column field="description" header="Planning Description" headerStyle={{ width: '10rem', textAlign: 'center' }} sortable body={bodyTemplate}></Column>
                        {/* <Column field="project" header="Project" headerStyle={{ width: '8rem', textAlign: 'center' }} sortable body={bodyTemplate}></Column> */}
                        <Column field="budgetamount" header="Budget Amount" headerStyle={{ width: '12rem', textAlign: 'center' }} sortable body={contractAmountBodyTemplate}></Column>                      
                        <Column field="rationale" header="Rationale" headerStyle={{ width: '14rem', textAlign: 'center' }} sortable body={bodyTemplate}></Column>
                        {/* <Column field="budgetsource" header="Budget Source" headerStyle={{ width: '8rem', textAlign: 'center' }} sortable body={bodyTemplate}></Column> */}
                        {/* <Column field="awards" header="Contract Amount" sortable body={contractAmountBodyTemplate}></Column> */}
                        {/* <Column field="awards" header="Project Status" headerStyle={{ width: '5.5rem', textAlign: 'center' }} sortable body={awardStatusBodyTemplate}></Column> */}
                        
                        
                    </DataTable>

                    
                </div>
            </div>

           
        </div>
    )
}
